import React, { useCallback, useEffect, useState, useRef } from "react"
import { graphql, Link } from "gatsby"
import "./_key-financials.scss"

import Layout from "§/src/components/layout"
import BreadcrumbCustomLevels from "§/src/components/atoms/breadcrumb/breadcrumb-customlevels"
import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"
import XlsxDataTable from "§/src/components/sections/xlsx-data-table"

// Internals
import { isEmpty } from "lodash"

const ContentTabs = React.lazy(() =>
  import("§/src/components/sections/content-tabs")
)
const ContactFooterNewsletter = React.lazy(() =>
  import("§/src/components/sections/contact/contact-footer-newsletter")
)
const RulerTitle = React.lazy(() =>
  import("§/src/components/atoms/title/ruler-title")
)

// utils
// import PswProtection from "§/src/utils/PswProtection";

// Import xlsx files
import { read, utils } from "xlsx"

// Switch Language
import { useTranslation } from "react-i18next"
import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="temp-key-financials is-theme-dark"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations}/>
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
    </React.Fragment>
  )
}

const TemplateKeyFinancials = props => {



  const { t } = useTranslation()

  //console.log('props?.pageContext?.acfPages_investors_key_financials',props?.pageContext?.acfPages_investors_key_financials);

  const keyFinancialDocument =
    props?.pageContext?.keyFinancialDocument?.acfoptGlobalOptions?.acfGlobal
      ?.keyFinancialDocument?.publicUrl

  const compFooterContact =
    props?.pageContext?.footerContact?.acfoptGlobalOptions?.acfGlobal
      ?.footerContact

  const activeSheet = props.pageContext?.acfPages_investors_key_financials?.sheet

	const asteriskLabel = props.pageContext?.acfPages_investors_key_financials?.incomeLabel
	const chartNotesBefore = props.pageContext?.acfPages_investors_key_financials?.incomeLabelBefore
	const chartNotesAfter = props.pageContext?.acfPages_investors_key_financials?.incomeLabelAfter

	const demContent = props.pageContext?.acfPages_investors_key_financials?.demContent
	const demPretitle = props.pageContext?.acfPages_investors_key_financials?.demPretitle
	const demTitle = props.pageContext?.acfPages_investors_key_financials?.demTitle

  /*

		kcf : Key Consolidated Figures
		ibs : Information by Sector
		sofp : Statement Of Financial Position
		sopl : Statement Of Profit (Loss)
		cfs : Cash Flow Statement

	*/

  // const [accessGranted, setAccessGranted] = useState(false);


  const [xlsxData, setXlsxData] = useState([])

  // Sheet 1
  const [ish, setIsh] = useState([]) // ish : Income Statement highlights (Principali Dati Economici)
  const [ishwm, setIshwm] = useState([]) // ishwm : Income Statement highlights (Principali Dati Economici) without Motion
  const [sfph, setSfph] = useState([]) // kcf : Statement of Financial Position Highlights (Principali Dati Patrimoniali-Finanziari
  const [fi, setFi] = useState([]) // fi: Financial Indicators (Indicatori Economico Finanziari)
  const [oi, setOi] = useState([]) // oi : Other Information (Altre Informazioni)

  // Sheet 2
  const [isbb, setIsbb] = useState([]) // isbb : Income Statement by Business (Informazioni economiche per settore di attività)
  const [ibb, setIbb] = useState([]) // ibb : Investments by Business (Investimenti per business)
  const [rbgr, setRbgr] = useState([]) //  rbgr : Revenues by Geographical Region (Ricavi per area geografica)
  const [ibgr, setIbgr] = useState([]) //  ibgr : Investments by Geographical Region (Investimenti per area geografica)

  // Sheet 3
  const [sofp, setSofp] = useState([]) // sofp : Statement Of Financial Position (Situazione patrimoniale finanziaria)

  // Sheet 4
  const [sopl, setSopl] = useState([]) // sopl : Statement Of Profit (Loss) (Conto Economico)

  // Sheet 5
  const [cfs, setCfs] = useState([]) // sopl : Statement Of Profit (Loss) (Conto Economico)

	// const fileLang = process.env.GATSBY_SITE_LANG == "it_IT" ? "-it-it" : "";

  useEffect(() => {
    ;(async () => {
      const f = await (
        await fetch("../../key-financial-gefran-20250330.xlsx")
      ).arrayBuffer()
      const wb = read(f) // parse the array buffer

      // SHEET 1
      // kcf: Key Consolidated Figures (Principali Dati Economici)

      const kcf_sheet = wb.Sheets[wb.SheetNames[0]] // get the first worksheet
      const kcf_obj = utils.sheet_to_json(kcf_sheet, { raw: true }) // generate objects
      kcf_obj.unshift({ title: Object.keys(kcf_obj[0])[0] }) // restore first group title
      const kcf_data = kcf_obj.map(item => {
        return Object.values(item)
      })

			kcf_data.shift();// remove first empty row

      // ish_data : Income Statement highlights (Principali Dati Economici)

      const ish_headers = kcf_data.slice(2, 3)
      ish_headers[0] = ["", ...ish_headers[0], ""] // add spacing cols

      const ish_data_table = tableDataPrep({
        headers: ish_headers,
        data: kcf_data.slice(3, 8),
        notes: { content: kcf_data.slice(1, 2)[0][0] },
        // spacers : {},
        // highlights : []
      })

      // add extra empty col for padding
      ish_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "string" })
      })

      setIsh({
        title: kcf_data[0].toString().toUpperCase(),
        table: ish_data_table,
      })

      // ishwm_data : Income Statement highlights (Principali Dati Economici) without Motion

      const ishwm_headers = kcf_data.slice(34, 35)
      ishwm_headers[0] = ["", ...ishwm_headers[0]] // add spacing cols

      const ishwm_data_table = tableDataPrep({
        headers: ishwm_headers,
        data: kcf_data.slice(35, 41),
        notes: { content: kcf_data.slice(33, 34)[0][0] },
        // spacers : {},
        // highlights : []
      })

      // add extra empty col for padding
      // ishwm_data_table.rows.forEach(row => {
      //   row.cols.push({ val: "", format: "string" })
      // })

      setIshwm({
        title: kcf_data[0].toString().toUpperCase(),
        table: ishwm_data_table,
      })


      // sfph_data : Statement of Financial Position Highlights (Principali Dati Patrimoniali-Finanziari)
      const sfph_headers = kcf_data.slice(10, 11)
      sfph_headers[0] = ["", ...sfph_headers[0], ""] // add spacing cols

      const sfph_data_table = tableDataPrep({
        headers: sfph_headers,
        data: kcf_data.slice(11, 17),
        notes: { content: kcf_data[9][0] },
        // spacers : {},
        // highlights : []
      })

      // add extra empty col for padding
      sfph_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "string" })
      })

      setSfph({
        title: kcf_data[8].toString().toUpperCase(),
        table: sfph_data_table,
      })

      // fi_data: Financial Indicators (Indicatori Economico Finanziari)
      const fi_headers = kcf_data.slice(18, 19)
      fi_headers[0] = ["", ...fi_headers[0], ""] // add spacing cols

      const fi_data_table = tableDataPrep({
        headers: fi_headers,
        data: kcf_data.slice(19, 26),
        // notes : null,
        // spacers : {},
        // highlights : []
      })

      // add format
      for (let r = 0; r < fi_data_table.rows.length; r++) {
        const row = fi_data_table.rows[r]
        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]
          if (r < 6) {
            col.format = "percent"
          } else {
            col.format = "eur"
          }
        }
      }

      // add extra empty col for padding
      fi_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "string" })
      })

      setFi({
        title: kcf_data[17].toString().toUpperCase(),
        table: fi_data_table,
      })

      // oi : Other information (Altre Informazioni)
      const oi_headers = kcf_data.slice(27, 28)
      oi_headers[0] = ["", ...oi_headers[0], ""]

      const oi_data_table = tableDataPrep({
        headers: oi_headers,
        data: kcf_data.slice(28, 32),
        // notes: null,
        // spacers: {},
        // highlights: []
      })

      // add extra empty col for padding
      oi_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "string" })
      })

      setOi({
        title: kcf_data[26].toString().toUpperCase(),
        table: oi_data_table,
      })

      // SHEET 2
      // ibs : Information by Sector (Dati per Settore)
      const ibs_sheet = wb.Sheets[wb.SheetNames[1]]
      const ibs_obj = utils.sheet_to_json(ibs_sheet) // generate objects
      ibs_obj.unshift({ title: Object.keys(ibs_obj[0])[0] }) // restore first group title
      const ibs_data = ibs_obj.map(item => {
        return Object.values(item)
      })

      // isbb : Income statement by business (Informazioni economiche per settore di attività)
      const isbb_headers = ibs_data.slice(2, 4)
      isbb_headers[0] = [...isbb_headers[0], ""]
      isbb_headers[1] = ["", ...isbb_headers[1], ""]

      const isbb_data_table = tableDataPrep({
        headers: isbb_headers,
        data: ibs_data.slice(4, 8),
        // notes: { content: ibs_data.slice(1,2)[0][0] },
        // spacers: {},
        // highlights: []
      })

      isbb_data_table.headers[0].colspan = [1, 5, 5]

      // add extra empty col for padding
      isbb_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "string" })
      })

      // add format
      for (let r = 0; r < isbb_data_table.rows.length; r++) {
        const row = isbb_data_table.rows[r]
        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]

          col.format == "int"

          if (c == 2 || c == 4 || c == 7 || c == 9) {
            col.format = "percent"
          }

          if (r == 4 && (c == 2 || c == 4 || c == 7 || c == 9)) {
            col.format = "string"
          }
        }
      }

      setIsbb({
        title: ibs_data[0].toString().toUpperCase(),
        table: isbb_data_table,
      })

      // ibb : Investments by Business (Investimenti per business)
      const ibb_headers = ibs_data.slice(10, 12)
      ibb_headers[0] = [...ibb_headers[0], ""]
      ibb_headers[1] = ["", ...ibb_headers[1], ""]

      const ibb_data_table = tableDataPrep({
        headers: ibb_headers,
        data: ibs_data.slice(12, 15),
        // notes: { content: ibs_data.slice(9,10)[0][0] },
        // spacers: {},
        // highlights: []
      })

      ibb_data_table.headers[0].colspan = [1, 3, 4]

      // add extra empty col for padding
      ibb_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "string" })
      })

      setIbb({
        title: ibs_data[8].toString().toUpperCase(),
        table: ibb_data_table,
      })


      //  rbgr : Revenues by Geographical Region (Ricavi per area geografica)
      const rbgr_headers = ibs_data.slice(17, 19)
      rbgr_headers[0] = [...rbgr_headers[0], ""]
      rbgr_headers[1] = ["", ...rbgr_headers[1], ""]

      const rbgr_data_table = tableDataPrep({
        headers: rbgr_headers,
        data: ibs_data.slice(19, 27),
        // notes: { content: ibs_data.slice(15,25)[0][0] },
        // spacers: {},
        // highlights: []
      })

      rbgr_data_table.headers[0].colspan = [1, 2, 2, 2]

      // add extra empty col for padding
      rbgr_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "spacer" })
      })

      // add format
      for (let r = 0; r < rbgr_data_table.rows.length; r++) {
        const row = rbgr_data_table.rows[r]
        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]

          col.format == "int"

          if (c == 1 || c == 3 || c == 5) {
            col.format = "percent"
          }
        }
      }

      setRbgr({
        title: ibs_data[15].toString().toUpperCase(),
        table: rbgr_data_table,
      })

      //  ibgr : Investments by Geographical Region (Investimenti per area geografica)
      const ibgr_headers = ibs_data.slice(29, 31)
      ibgr_headers[0] = [...ibgr_headers[0], ""]
      ibgr_headers[1] = ["", ...ibgr_headers[1], ""]

      const ibgr_data_table = tableDataPrep({
        headers: ibgr_headers,
        data: ibs_data.slice(31, 38),
        // notes: { content: ibs_data.slice(26,27)[0][0] },
        // spacers: {},
        // highlights: []
      })

      ibgr_data_table.headers[0].colspan = [1, 2, 2]

      // ibgr_data_table.headers = [{cols: ["", ibgr_data[0][1], ibgr_data[0][2] ], colspan: [1,2,2]}, ...ibgr_data_table.headers];

      // add extra empty col for padding
      ibgr_data_table.rows.forEach(row => {
        row.cols.push({ val: "", format: "spacer" })
      })

      // add format
      for (let r = 0; r < ibgr_data_table.rows.length; r++) {
        const row = ibgr_data_table.rows[r]

        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]

          col.format == "int"

          if ((r == 2 || r == 3 || r == 5) && c == 0) {
            col.format = "int"
          }
        }
      }

      setIbgr({
        title: ibs_data[27].toString().toUpperCase(),
        table: ibgr_data_table,
      })

      // SHEET 3
      // sofp : Statement Of Financial Position (Situazione patrimoniale finanziaria)
      const sofp_sheet = wb.Sheets[wb.SheetNames[2]]
      const sofp_sheet_obj = utils.sheet_to_json(sofp_sheet) // generate objects
      sofp_sheet_obj.unshift({ title: Object.keys(sofp_sheet_obj[0])[0] }) // restore first group title
      const sofp_sheet_data = sofp_sheet_obj.map(item => {
        return Object.values(item)
      })

      // sofp : Statement Of Financial Position (Situazione patrimoniale finanziaria)
      const sofp_headers = sofp_sheet_data.slice(1, 3)
      sofp_headers[0] = [...sofp_headers[0], ""]
      sofp_headers[1] = ["", ...sofp_headers[1], ""]

      const sofp_data_table = tableDataPrep({
        headers: sofp_headers,
        data: sofp_sheet_data.slice(3, 27),
        // notes: { content: sofp_sheet_data.slice(1,2)[0][0] },
        highlights: [3, 8, 12, 13, 21, 22],
        spacers: { rows: [4, 10, 14, 16, 18, 29], colspan: 7 },
      })

      sofp_data_table.headers[0].colspan = [1, 2, 2]

      // add extra empty col for padding
      sofp_data_table.rows.forEach(row => {
        if (row.rowHeader !== null) {
          // skip spacer rows
          row.cols.push({ val: "", format: "string" })
        }
      })

      // add format
      for (let r = 0; r < sofp_data_table.rows.length; r++) {
        const row = sofp_data_table.rows[r]
        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]

          col.format == "int"

          if ((row.rowHeader !== null && c == 1) || c == 3) {
            col.format = "percent-int"
          }

          if (r == 4 && (c == 1 || c == 3)) {
            // col.format = "string";
          }
        }
      }

      setSofp({
        title: sofp_sheet_data[0].toString().toUpperCase(),
        table: sofp_data_table,
      })

      // SHEET 4

      // sopl : Statement Of Profit (Loss) (Conto Economico)
      const sopl_sheet = wb.Sheets[wb.SheetNames[3]]
      const sopl_sheet_obj = utils.sheet_to_json(sopl_sheet) // generate objects
      sopl_sheet_obj.unshift({ title: Object.keys(sopl_sheet_obj[0])[0] }) // restore first group title
      const sopl_sheet_data = sopl_sheet_obj.map(item => {
        return Object.values(item)
      })

      // sopl : Statement Of Profit (Loss) (Conto Economico)
      const sopl_headers = sopl_sheet_data.slice(1, 3)
      sopl_headers[0] = ["", ...sopl_headers[0], ""]
      sopl_headers[1] = ["", ...sopl_headers[1], ""]

      const sopl_data_table = tableDataPrep({
        headers: sopl_headers,
        data: sopl_sheet_data.slice(3, 19),
        // notes: { content: sopl_sheet_data.slice(1,2)[0][0] },
        // spacers: {rows: [4,10,14,16,18,27], colspan: 7},
        highlights: [3, 6, 8, 11, 13, 15],
      })

      sopl_data_table.headers[0].colspan = [2, 1, 1, 2]

      // sopl_data_table.headers = [{cols: ["", sopl_data[0][1], sopl_data[0][2], sopl_data[0][3]], colspan: [2,1,1,3]}, ...sopl_data_table.headers];

      // add extra empty col for padding
      sopl_data_table.rows.forEach(row => {
        if (row.rowHeader !== null) {
          // skip spacer rows
          row.cols.push({ val: "", format: "string" })
        }
      })

      // add format
      for (let r = 0; r < sopl_data_table.rows.length; r++) {
        const row = sopl_data_table.rows[r]
        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]

          col.format == "int"

          if (row.rowHeader !== null && c == 4) {
            col.format = "percent"
          }

          if (c == 0) {
            col.format = "string"
          }
        }
      }

      setSopl({
        title: sopl_sheet_data[0].toString().toUpperCase(),
        table: sopl_data_table,
      })

      // SHEET 5

      // cfs : Cash Flow Statement (Rendiconto Finanziario)
      const cfs_sheet = wb.Sheets[wb.SheetNames[4]]
      const cfs_sheet_obj = utils.sheet_to_json(cfs_sheet) // generate objects
      cfs_sheet_obj.unshift({ title: Object.keys(cfs_sheet_obj[0])[0] }) // restore first group title
      const cfs_sheet_data = cfs_sheet_obj.map(item => {
        return Object.values(item)
      })

      // cfs : Statement Of Profit (Loss) (Rendiconto Finanziario)

      const cfs_headers = cfs_sheet_data.slice(1, 2)
      cfs_headers[0] = [...cfs_headers[0], ""]

      const cfs_data = cfs_sheet_data.slice(2, 48)

      const cfs_colspans = []
      cfs_colspans[1] = [3]
      cfs_colspans[18] = [3]
      cfs_colspans[19] = [3]
      cfs_colspans[27] = [3]

      const cfs_data_table = tableDataPrep({
        headers: cfs_headers,
        data: cfs_data,
        colspans: cfs_colspans,
        // notes: { content: cfs_sheet_data.slice(0,2)[0][0] },
        highlights: [0, 1, 17, 18, 25, 26, 27, 37, 38, 40, 41],
        spacers: { rows: [0, 2, 20, 29, 31, 43, 45, 47, 49], colspan: 4 },
      })

      // add extra empty col for padding
      cfs_data_table.rows.forEach(row => {
        if (row.rowHeader !== null) {
          // skip spacer rows
          row.cols.push({ val: "", format: "string" })
        }
      })

      // add format
      for (let r = 0; r < cfs_data_table.rows.length; r++) {
        const row = cfs_data_table.rows[r]
        for (let c = 0; c < row.cols.length; c++) {
          const col = row.cols[c]

          col.format == "int"

          if (row.rowHeader !== null && c == 4) {
            col.format = "string"
          }
        }
      }

      setCfs({
        title: cfs_sheet_data[0].toString().toUpperCase(),
        table: cfs_data_table,
      })

      // setXlsxData(keyFinancialsData); // update state
    })()
  }, [])

  let tabbedContent = []

  let regularContent = []

  switch (activeSheet) {
    case "kcf": // Key Consolidated Figures
      tabbedContent = [
        {
          subtitle: ish.title,
          content: (
            <>
              <XlsxDataTable
                tableType="simple-data"
                toggleType="checkbox"
                tableData={ish.table}
                tableID="ish"
                noBackground={false}
                displayDanger={true}
								asteriskLabel={asteriskLabel}
								chartNotesBefore={chartNotesBefore}
								chartNotesAfter={chartNotesAfter}
								skip={5}
              />
              <div className="tile additional-chart">
                <div className="row mb-3 mb-md-5">
                  <div className="col-md-7">
                    <div className="d-flex flex-column gap-2">
                      <RulerTitle
                        pretitle={demPretitle}
                        title={demTitle}
                        disableDivider={true}
                      />
										{ demContent && ( <p className="fs-16 text-gray">{demContent}</p> ) }
                    </div>
                  </div>
                </div>
                <XlsxDataTable
                  tableType="simple-data"
                  tableData={ishwm.table}
                  tableID="ishwm"
									// showLines={[0]}
									toggleType="radio"
                  noBackground={true}
                  displayDanger={false}
                />
              </div>
            </>
          ),
        },
        {
          subtitle: sfph.title,
          content: (
            <XlsxDataTable
              tableType="simple-data"
              toggleType="checkbox"
							chartNotesAfter={chartNotesAfter}
							asteriskLabel={asteriskLabel}
              tableData={sfph.table}
              tableID="sfph"
            />
          ),
        },
        {
          subtitle: fi.title,
          content: (
            <XlsxDataTable
              tableType="simple-data"
							asteriskLabel={asteriskLabel}
              tableData={fi.table}
              tableID="fi"
            />
          ),
        },
        {
          subtitle: oi.title,
          content: (
            <XlsxDataTable
              tableType="simple-data"
							asteriskLabel={asteriskLabel}
              tableData={oi.table}
              tableID="oi"
            />
          ),
        },
      ]
      break
    case "ibs": // Information by Sector
      tabbedContent = [
        {
          subtitle: isbb.title,
          content: (
            <XlsxDataTable
              tableType="simple-data"
              tableData={isbb.table}
              tableID="isbb"
            />
          ),
        },
        {
          subtitle: ibb.title,
          content: (
            <XlsxDataTable
              tableType="simple-data"
              tableData={ibb.table}
              tableID="ibb"
            />
          ),
        },
        {
          subtitle: rbgr.title,
          content: (
            <XlsxDataTable
              tableType="toggle-rows"
              toggleType="checkbox"
              tableData={rbgr.table}
              tableID="rbgr"
            />
          ),
        },
        {
          subtitle: ibgr.title,
          content: (
            <XlsxDataTable
              tableType="toggle-rows"
              toggleType="checkbox"
              tableData={ibgr.table}
              tableID="ibgr"
            />
          ),
        },
      ]
      break
    case "sofp": // Statement Of Financial Position
      regularContent = {
        content: (
          <XlsxDataTable
            tableType="simple-data"
            tableData={sofp.table}
            tableID="sofp"
          />
        ),
      }
      break
    case "sopl": // Statement Of Profit (Loss)
      regularContent = {
        content: (
          <XlsxDataTable
            tableType="simple-data"
            tableData={sopl.table}
            tableID="sopl"
          />
        ),
      }
      break
    case "cfs": // Cash Flow Statement (Rendiconto Finanziario)
      regularContent = {
        content: (
          <XlsxDataTable
            tableType="simple-data"
            tableData={cfs.table}
            tableID="cfs"
          />
        ),
      }
      break

    default:
      break
  }

  return (
    <Layout
      lang={props?.data?.lang?.translations}
      className={"is-theme-dark"}
      breadcrumbs={true}
    >

      <BreadcrumbCustomLevels
        levels="1"
        wpseo={props?.pageContext?.seo?.breadcrumbs}
        base={t("Investor relations")}
        className="dark-crumbs no-links mb-0"
      />
      {!isEmpty(props?.pageContext) ? (
        <React.Suspense fallback={<LoadingFrame />}>
          <div className="bg-full g-100 pt-4 pb-6 mb-5 mb-md-7">
            <h1 className="fs-30">{props?.pageContext?.title}</h1>
          </div>
          {tabbedContent.length > 0 && (
            <ContentTabs data={tabbedContent} />
          )}
          {regularContent ? regularContent.content : ""}
          {compFooterContact && (
            <ContactFooterNewsletter data={compFooterContact} className={"mt-7 mt-md-9"} />
          )}
        </React.Suspense>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

function tableDataPrep(props) {
  const headers = props.headers || []
  const data = null ?? props.data
  const colspans = props.colspans || []
  const notes = null ?? props.notes
  const spacers = null ?? props.spacers
  const highlights = props.highlights || []

  if (!data) return false

  // init object
  const tableObj = {
    headers: [],
    rows: [],
    notes: null ?? notes,
  }

  // add headers
  for (let i = 0; i < headers.length; i++) {
    let header = headers[i]
    if (header) tableObj.headers.push({ cols: [...header] })
  }

  // add data
  for (let r = 0; r < data.length; r++) {
    // when no colspans object is present, create empty array
    let rColSpans = colspans[r] || Array(data[r].length)
    let rhColspan = rColSpans[0] || false

    // init row, add row header
    let row = {
      rowHeader: {
        val: data[r][0],
        colspan: rhColspan,
      },
      cols: [],
    }

    // loop cols
    for (let c = 1; c < data[r].length; c++) {
      const col = {
        val: data[r][c],
        format: "int",
        colspan: false ?? rColSpans[r][c],
      }
      row.cols.push(col)
    }
    tableObj.rows.push(row)
  }

  // add highlights
  if (highlights.length) {
    for (let h = 0; h < highlights.length; h++) {
      const highlight = highlights[h]
      if (tableObj.rows[highlight]) {
        tableObj.rows[highlight].className = "highlight"
      }
    }
  }

  // add spacers
  if (spacers) {
    let colspan = spacers.colspan

    for (let s = 0; s < spacers.rows.length; s++) {
      const spacerPos = spacers.rows[s]
      tableObj.rows.splice(spacerPos, 0, {
        rowHeader: null,
        cols: [{ val: "", format: "string" }],
        colspan: [colspan],
      })
    }
  }

  return tableObj
}

export default TemplateKeyFinancials

export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    lang: wpPage(slug: { eq: $eq }) {
      translations {
        postUrl
        siteId
      }
    }
  }
`
